import script from "./logging.banzaicloud.io.clusteroutput.vue?vue&type=script&lang=js"
export * from "./logging.banzaicloud.io.clusteroutput.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__